import React, { useEffect } from 'react';
import LoginForm from './modules/session/LoginForm';
import ConfiguringApp from './modules/session/ConfiguringApp';
import UILayout from './modules/layoutv2/UILayout';
import { useSelector, useDispatch } from 'react-redux';
import ErrorBoundary from './modules/layout/ErrorBoundary';
import VERSION from './version';
import { resetState, restoreSession } from './modules/session/session-actions'
import useSessionKeepAlive from './modules/session/useSessionKeepAlive';
import { useParams } from 'react-router-dom';
import { subscribeToUpdateStatus } from './modules/update/update-actions';
import UpdateDialog from './modules/update/UpdateDialog';

const runEnv = window?.bodapro ? 'desktop' : 'web';

if(!window.bodapro){
	window.bodapro = {
		// platformType: process.versions['electron'] ? 'desktop': 'web',
		// platformType: window && window.process ? 'desktop': 'web',
		platformType: runEnv,
		dbQuery : () => false,
		migrateUp: () => {},
		submitCode: () => {},
		addToLog: () => {},
		getInstalledExtensions: () => {},
		api : {
			listenOn: () => {},
			removeListener: () => {},
			sendMessage: () => {},
		},
		fs: { existsSync: (v) => true },
		runWorker: () => {}, //@todo: implement web socket for server implementation
		listenOn: () => {},
		removeListener: () => {},
		getConfig: () => {},
		checkForUpdate: () => Promise.resolve({ success: false }),
		downloadUpdate: () => Promise.resolve({ success: false }),
		installUpdate: () => Promise.resolve({ success: false }),
		getUpdateStatus: () => Promise.resolve({ state: 'idle' }),
		onUpdateStatus: () => () => {},
	};

}

const App = () => {
	const [loading, setLoading] = React.useState(true);
	const { authenticated, version, updating } = useSelector((state) => state.session);
	const [ error,setError ] = React.useState(null);
	const [ errorInfo,setErrorInfo ] = React.useState(null);
	const dispatch = useDispatch();
	let { extension } = useParams();

	useEffect(() => {
		VERSION !== version && dispatch(resetState());


		//Restore the session, refreshing the token if it has expired
		dispatch(restoreSession());

		//Subscribe to main-process update status pushes
		dispatch(subscribeToUpdateStatus());
	}, [1]);

	//Silently refresh the access token before it expires
	useSessionKeepAlive();

	//show updating skin
	// if(updating) {
	// 	return <ConfiguringApp />;
	// }

	// authentication
	// if(window.bodapro?.platformType == 'web'){//show authentication for web
	if(runEnv == 'web'){//show authentication for web


		//@todo: load single extension
		if(extension !== undefined ){

			return <div>Loading ...</div>
		}

		if (authenticated === false) {
			return (
				<ErrorBoundary>
					<LoginForm/>
				</ErrorBoundary>
			);
		}
	}


	return (
		<ErrorBoundary>
			<UILayout />
			<UpdateDialog/>
		</ErrorBoundary>
	);
}

export default App;